export const DGC_ORDERS_DEFAULT_PAGE_NUM = 1;
export const DGC_ORDERS_PAGE_SIZE = 15;
export const DGC_EXPORT_ROW_NUM = 500;

export const ALL = 'all';
